import { Link } from '@rulebooks/evidend-titan';
import { t, Trans } from '@lingui/macro';
import { SidebarFormContainer, SidebarFormContent } from 'components/SidebarForm/SidebarForm';
import { setFormErrors } from 'forms/helpers/setFormErrors';
import type { LegalEntity } from 'generated/gql';
import { useAddKvkNumberToLegalEntityMutation } from 'generated/gql';
import { useGlobalError } from 'hooks/useGlobalError';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { kvkFormSchema, KvkSidebarForm } from './KvkSidebarForm';

interface IKvkSidebarLink {
  legalEntity: Partial<LegalEntity>;
}

export const KvkSidebarLink = ({ legalEntity }: IKvkSidebarLink) => {
  const router = useRouter();
  const [, setGlobalError] = useGlobalError();
  const [isFormDrawerShown, setFormDrawerShown] = useState<boolean>(false);
  const [addKvkNumberToLegalEntity] = useAddKvkNumberToLegalEntityMutation();
  return (
    <>
      <SidebarFormContainer isDrawerShown={isFormDrawerShown}>
        <SidebarFormContent
          form={<KvkSidebarForm />}
          formSchema={kvkFormSchema}
          header={t`KVK-nummer toevoegen`}
          setDrawerClosed={() => setFormDrawerShown(false)}
          onSubmit={({ kvkNumber }) => {
            addKvkNumberToLegalEntity({
              variables: {
                legalEntityId: legalEntity.id || '',
                kvkNumber,
              },
              onCompleted: ({ addKvkNumberToLegalEntity }) => {
                setFormDrawerShown(false);
                router.push({
                  pathname: `/rechtspersoon/${addKvkNumberToLegalEntity.id}`,
                });
              },
              onError: ({ graphQLErrors }) => {
                setFormErrors({ errors: graphQLErrors, setGlobalError });
              },
            });
          }}
        />
      </SidebarFormContainer>

      <Link onClick={() => setFormDrawerShown(true)}>
        <Trans>KVK-nummer toevoegen</Trans>
      </Link>
    </>
  );
};
